export default __webpack_public_path__ + "static/media/AddNew.d3c4e029.svg";